'use strict';

var angular = require('angular');
var _ = require('lodash');
var gridColumns = require('../config/details-length-of-stay-grid-columns.json');
var gridDataFields = require('../config/details-length-of-stay-grid-data-fields.json');
var DetailsLengthOfStayGridController = function DetailsLengthOfStayGridController($scope, dataRetriever, detailsLengthOfStayRenderersFactory, detailsLengthOfStayGridService, legendFilterService, hepService, jqxGridSettingsService, gridTooltipService, featureToggleService) {
  var dynamicPricingEnabled = featureToggleService.isEnabled('DYNAMIC_PRICING');
  var ATPCO_SELLUP_COLUMN = 'atpcoSellUp';
  var source = {
    localdata: [],
    datafields: gridDataFields.datafields
  };
  function prepareColumns() {
    var columns = gridColumns.columns;
    _.transform(columns, function (result, column) {
      if (column.renderer) {
        column.cellsrenderer = detailsLengthOfStayRenderersFactory[column.renderer];
        column.renderer = null;
      }
      column.cellclassname = detailsLengthOfStayGridService.cellClassName;
      result.push(column);
    }, []);
    return columns;
  }
  function tooltipHandler(cellElement, pageX, pageY, cellData) {
    gridTooltipService.tooltipTrigger(getFareClassCellForPositionReference(cellElement), pageX, pageY, cellData, $scope.gridSettings.source.loadedData, $scope.gridId, null, null);
  }
  function getFareClassCellForPositionReference(cellElement) {
    if (cellElement && cellElement.parentElement) {
      return cellElement.parentElement.getElementsByClassName('fare-class-cell')[0];
    }
    return cellElement;
  }
  $scope.gridId = 'details-length-of-stay-grid';
  $scope.gridSettings = {
    width: '100%',
    height: 200,
    altrows: true,
    enablehover: false,
    filterable: true,
    sortable: true,
    columns: prepareColumns(),
    source: new angular.element.jqx.dataAdapter(source, {
      beforeLoadComplete: function beforeLoadComplete() {
        updateAtpcoSellupColumnVisibility($scope.gridSettings);
      }
    })
  };
  if (dynamicPricingEnabled) {
    $scope.gridSettings.enablehover = true;
    $scope.gridSettings.cellhover = {
      handler: tooltipHandler
    };
  }
  function showAtpcoSellupColumn(gridSettings, visible) {
    var columnAction = visible ? 'showcolumn' : 'hidecolumn';
    if (gridSettings.jqxGrid) {
      gridSettings.jqxGrid('beginUpdate');
      gridSettings.jqxGrid(columnAction, ATPCO_SELLUP_COLUMN);
      gridSettings.jqxGrid('endUpdate');
    }
  }
  function updateAtpcoSellupColumnVisibility(gridSettings) {
    if ($scope.market) {
      var marketEndpoints = $scope.market.split('-', 2);
      if (marketEndpoints && marketEndpoints.length === 2) {
        hepService.getFPMarketConfigParams(marketEndpoints[0], marketEndpoints[1]).then(function (data) {
          showAtpcoSellupColumn(gridSettings, _.get(data, 'hepList[0].properties.marketConfigParams.isUseNGDS', false));
        });
      }
    }
  }
  $scope.resetGrid = function () {
    source.localdata = [];
    jqxGridSettingsService.resetFilterAndSorting($scope.gridSettings);
    $scope.gridSettings.source.dataBind();
  };
  function populateGridTitle(lengthOfStay, carryCount) {
    $scope.market = legendFilterService.getSelectedMarket();
    $scope.cabin = legendFilterService.getSelectedCabin();
    $scope.pos = legendFilterService.getSelectedPos();
    $scope.lengthOfStay = lengthOfStay;
    $scope.carryCount = carryCount;
  }
  $scope.retrieveData = function (referenceService, originalService) {
    $scope.resetGrid();
    dataRetriever.getData(referenceService, originalService, $scope.snapshotDate).then(function (data) {
      populateGridTitle(_.get(referenceService, 'lengthOfStay'), _.get(originalService, 'carryCount'));
      source.localdata = data;
      $scope.gridSettings.source.dataBind();
    });
  };
};
DetailsLengthOfStayGridController.$inject = ['$scope', 'DetailsLengthOfStayGridDataRetrieverService', 'DetailsLengthOfStayRenderersFactory', 'DetailsLengthOfStayGridService', 'PricingDepartureDatesLegendFilterService', 'HepService', 'JQXGridSettingsService', 'GridTooltipService', 'FeatureToggleService'];
module.exports = DetailsLengthOfStayGridController;